import { useEffect, useState } from 'react';
import { LockKeyhole, Diamond } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Tag } from '../shared';

export const PassportPortrait = ({ src, name = 'Trainer', id, large = false }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  const initials = name.split(/\s+/).filter(Boolean).map(n => n[0]).slice(0, 2).join('');
  const colors = ['#66d7eb', '#efce69', '#ec8e9a', '#96cfb8'];
  const color = colors[[...name].reduce((sum, char) => sum + char.charCodeAt(0), 0) % colors.length];
  return <div className={`pp-portrait ${large ? 'pp-portrait-large' : ''}`} style={{ '--portrait-accent': color }} data-testid={id}>
    {src && !failed ? <img src={src} alt={name} onError={() => setFailed(true)} data-testid={`${id}-image`} /> : <span data-testid={`${id}-initials`}>{initials}</span>}
  </div>;
};

export const SkillTags = ({ tags, id }) => <div className="pp-tags" data-testid={id}>
  {tags.map((tag, index) => <Tag className="pp-skill" data-testid={`${id}-${index}`} key={`${tag}-${index}`}>{tag}</Tag>)}
</div>;

export const PassportEmpty = ({ id, title, children, icon: Icon = Diamond }) => <div className="pp-empty" data-testid={id}>
  <Icon size={25} /><h3 data-testid={`${id}-title`}>{title}</h3>{children && <p data-testid={`${id}-message`}>{children}</p>}
</div>;

export const PassportDialog = ({ id, title, description, onClose, children }) => <Dialog open onOpenChange={open => !open && onClose()}>
  <DialogContent className="apex-modal pp-scope pp-dialog passport-refresh" data-testid={id} closeTestId={`${id}-close`}>
    <DialogTitle data-testid={`${id}-title`}>{title}</DialogTitle>
    <DialogDescription data-testid={`${id}-description`}>{description}</DialogDescription>
    {children}
  </DialogContent>
</Dialog>;

export const PrivateNotice = () => <PassportEmpty id="pp-private-metrics" title="Scores stay in the athlete’s corner." icon={LockKeyhole}>
  Evaluation scores are private to the parent and connected trainers.
</PassportEmpty>;